import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useLocation } from "react-router-dom";
// import { UpdateProjectAllDetails, AddContractor } from "./ProjectDetailsCrudButtons";

import { handleErrorToast, formatCurrencyIndian } from "../CustomFunctions";
import { CircularGrid, ProjectIcon, DocumentIcon } from "../AllSvg";
import usePermission from "../../config/permissions";
// import { VehicleModelTable } from "./VehicleManagement/VehicleManagementComponenets";
// import { SiteInventory } from "./InventoryManagement/InventoryManagementComponent";
// import { UploadBulkContractor } from "./BulkModals";

import { useNavigate } from "react-router-dom";

const BidDetails = () => {
    const location = useLocation();
    const { projectID } = usePermission();

    const projectIdd = projectID
        ? projectID
        : location.state?.project?.id
            ? location.state?.project?.id
            : location?.state?.project;
    const [buffer, setBuffering] = useState(false);
    console.log(location.state, "location");
    // State Variables
    const tender = location.state?.data
        ? location.state?.data
        : location?.state?.data;
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const [contractorlist, setContractorList] = useState([]);
    const [contractor, setContractor] = useState(null);
    const [siteProject, setSiteProject] = useState();

    const [toggleState, setToggleState] = useState("contractor");
    const [toggleStatehange, setToggleStatechange] = useState(
        location?.state?.toggle ? location?.state?.toggle : 10,
    );
    // const [toggleStatehange, setToggleStatechange] = useState(10);
    const [consultancyDetailsDetails, setConsultancyDetailsData] = useState([]);
    const role = sessionStorage.getItem("sitemanagement_role");
    // Function to Fetch Project Data
    const getProjects = async () => {
        setBuffering(true);
        try {
            const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSiteSubCompanyList(sub.data);

            const proj = await axios.get(
                `${BASE_URL}/siteproject/bids/${projectIdd}/`,
            );
            // setProjectsData(proj.data);
        } catch (err) {
            // handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const getConsultancyDetails = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(
                `${BASE_URL}/siteproject/contractor/${contractor}/`,
            );
            setConsultancyDetailsData(response.data);
        } catch (err) {
        } finally {
            setBuffering(false);
        }
    };

    const getProjectContractorDetails = async () => {
        setBuffering(true);
        try {
            const contractordetails = await axios.get(
                `${BASE_URL}/siteproject/contractorbyproject/${projectIdd}/null/`,
            );
            setContractorList(contractordetails.data);

            // Check if the contractor list is not empty and set the last contractor as selected
            if (contractordetails.data.length > 0) {
                setContractor(contractordetails.data.slice(-1)[0]?.id); // Using slice to get the last contractor
            } else {
                setContractor(undefined); // or handle it accordingly
            }
        } catch (err) {
            // handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };
    // Load Data on Initial Render
    useEffect(() => {
        if (projectIdd != undefined && projectIdd != "") {
            getProjects();
            // getProjectContractorDetails();
            getConsultancyDetails();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractor, projectIdd]);

    // Effect to Handle Toggle State Changes
    useEffect(() => {
        if (toggleState === "contractor") {
            getProjectContractorDetails();
            // Set default toggleStatehange for contractor view
            setToggleStatechange(11);
        }
        if (toggleState === "consultant") {
            setToggleStatechange(10); // Set to consultant default
            setContractor(null);
        }
        // Add additional logic if needed
    }, [toggleState]);

    const formatDate = (dateString) => {
        if (!dateString) return "Not specified";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    };

    // Calculate days left
    const getDaysLeft = (dateString) => {
        if (!dateString) return "N/A";
        const today = new Date();
        const dueDate = new Date(dateString);
        const diffTime = dueDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays > 0 ? `${diffDays} days left` : "Closed";
    };
    const [letterData, setLetterData] = useState("");
    const displayValue = (value) => {
        if (typeof value === "boolean") return value ? "Yes" : "No";
        return value || "-";
    };

    const [tab, setTab] = useState(0);

    const showEligibility = tender?.is_in_bidlist && tender?.is_in_targetlist;
    const showPartners = showEligibility && tender?.is_finalize;
    const showSubmission = showPartners && tender?.is_submitted;

    const tabRowStyle = {
        display: "flex",
        gap: 16,
        borderBottom: "1px solid #e0e0e0",
        marginBottom: 18,
    };
    const tabBtnStyle = (active) => ({
        background: "none",
        border: "none",
        fontWeight: 600,
        padding: "10px 18px",
        cursor: "pointer",
        color: active ? "#3867d6" : "#2B3A67",
        transition: "all 0.2s",
        borderBottom: active ? "3px solid #3867d6" : "3px solid transparent",
        marginBottom: -1,
        fontSize: "1rem",
        outline: "none",
    });
    const tabContentStyle = { marginTop: 8 };
    const tableStyle = {
        width: "100%",
        borderCollapse: "collapse",
    };
    const trStyle = {
        borderBottom: "1px solid #efefef",
    };
    const tdLabelStyle = {
        width: 210,
        color: "#616161",
        fontWeight: 400,
        padding: "9px 11px 9px 0",
    };
    const tdColonStyle = { width: 10, color: "#aaa", fontWeight: 400 };
    const thValueStyle = {
        fontWeight: 600,
        padding: "9px 0",
        textAlign: "left",
    };

    const navigate = useNavigate();

    const handleBackToTenders = () => {
        navigate(
            `/${window.location?.pathname?.split("/")[1] || "certificaionadminaccess"}/tender/`,
        );
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* <Dashboardnavbar name={`Bid Tender Details`} url="Site Project" /> */}
            <div
                className="dashboard-main-section"
                style={{ width: "100%", background: "#f4f7fe", height: "auto" }}
            >
                <div className="content-tabs" style={{ width: "100%" }}>
                    <div className="info-box-div-bg">
                        <div className="jd-heading-outer heading-bg-color-white">
                            <div
                                onClick={handleBackToTenders}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    boxSizing: "border-box",
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                }}
                            >
                                {"< Back"}
                            </div>
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600 font-size-heading">
                                    Tender Details of :"{tender?.tender_name} "
                                </h2>
                                <div>
                                    {tender?.document && (
                                        <a href={tender?.document} target="blank">
                                            <div className="upload-svg">View Tender Document</div>
                                        </a>
                                    )}
                                </div>
                            </div>
                            <div>
                                <div
                                    className="jd-heading-bottom-bold"
                                    style={{ width: "28vw", height: "2px" }}
                                ></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>
                        <div
                            style={{ width: "100%", fontFamily: "sans-serif", fontSize: 15 }}
                        >
                            {/* Tabs Row */}
                            <div style={tabRowStyle}>
                                <button
                                    style={tabBtnStyle(tab === 0)}
                                    onClick={() => setTab(0)}
                                >
                                    Overview
                                </button>
                                {showEligibility && (
                                    <button
                                        style={tabBtnStyle(tab === 1)}
                                        onClick={() => setTab(1)}
                                    >
                                        Eligibility
                                    </button>
                                )}
                                {showPartners && (
                                    <button
                                        style={tabBtnStyle(tab === 2)}
                                        onClick={() => setTab(2)}
                                    >
                                        Partners
                                    </button>
                                )}
                                {showSubmission && (
                                    <button
                                        style={tabBtnStyle(tab === 3)}
                                        onClick={() => setTab(3)}
                                    >
                                        Submission
                                    </button>
                                )}
                            </div>
                            {/* Tab Content */}
                            <div style={tabContentStyle}>
                                {tab === 0 && (
                                    <table style={tableStyle}>
                                        <tbody>
                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Tender Name</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.tender_name)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Status</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.status)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Lead Partner</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.lead_partner)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>JV Partner</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.jv_partner_name)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Associate Partner</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.associate_with_version)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Type of Project</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.type_of_project)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>KM Cost</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.km_cost)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Fee</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.fee)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Bid Security</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.bid_security)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>EMD</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.emd)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Eligibility Criteria</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.eligibity_criteria)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Remarks</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.remarks)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Special Structure Type</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.special_structure_type)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Other Sector Type</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.other_sector_type)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Other Tender Type</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.other_tender_type)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>RO</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.ro)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>PBG Required</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.pbg_requried)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>PBG Details</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.pbg_details)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Tender Source</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.tender_source)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Sent</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.sent)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Received</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.recieve)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Is EMD Required</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.is_emd_required)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Exempted EMD</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.exmpted_emd)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>EMD Amount</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.emd_amount)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>EMD Type</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.emd_type)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>EMD Submission Type</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.emd_submission_type)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Custom EMD Type</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.custom_emd_type)}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                )}
                                {/* Eligibility */}
                                {tab === 1 && showEligibility && (
                                    <table style={tableStyle}>
                                        <tbody>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Eligibility Criteria</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.eligibity_criteria
                                                        ? tender?.eligibity_criteria === "Special"
                                                            ? tender?.eligibity_criteria_special
                                                            : tender?.eligibity_criteria
                                                        : ""}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>JV Allowed</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.is_jv_allowed ? "Yes" : "NO"}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Consortium/Association Allowed</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.is_jv_consorium_association_allowed ? "Yes" : "NO"}
                                                </th>
                                            </tr>

                                            {tender?.is_jv_consorium_association_allowed && (
                                                <tr style={trStyle}>
                                                    <td style={tdLabelStyle}>Terms of JV</td>
                                                    <td style={tdColonStyle}>:</td>
                                                    <th style={thValueStyle}>
                                                        {displayValue(tender?.terms_of_jv)}
                                                    </th>
                                                </tr>
                                            )}

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Company Name</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.company_name
                                                        ? tender?.company_name.toUpperCase()
                                                        : ""}
                                                </th>
                                            </tr>

                                            {tender?.company_name === "joint" && (
                                                <>
                                                    <tr style={trStyle}>
                                                        <td style={tdLabelStyle}>Company Dist JV</td>
                                                        <td style={tdColonStyle}>:</td>
                                                        <th style={thValueStyle}>
                                                            {displayValue(tender?.company_dist_jv)}
                                                        </th>
                                                    </tr>

                                                    <tr style={trStyle}>
                                                        <td style={tdLabelStyle}>Company Dist Lead</td>
                                                        <td style={tdColonStyle}>:</td>
                                                        <th style={thValueStyle}>
                                                            {displayValue(tender?.company_dist_lead)}
                                                        </th>
                                                    </tr>
                                                </>
                                            )}

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Total Tech Score</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.tech_score)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Company Score</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.company_score)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Sole Qualify</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.soil_quality ? "Yes" : "NO"}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Participating As</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.participating_as)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Site Apprisate Marking</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.site_apprisate_marking
                                                        ? tender?.site_apprisate_marking
                                                        : "No"}
                                                </th>
                                            </tr>


                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Work Methodology Marking</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.work_methodology_marking
                                                        ? tender?.work_methodology_marking
                                                        : "No"}
                                                </th>
                                            </tr>



                                            <>
                                                <tr style={trStyle}>
                                                    <td style={tdLabelStyle}>Presentation Required Marking</td>
                                                    <td style={tdColonStyle}>:</td>
                                                    <th style={thValueStyle}>
                                                        {tender?.presentation_required_marking
                                                            ? tender?.presentation_required_marking
                                                            : "No"}
                                                    </th>
                                                </tr>

                                                <tr style={trStyle}>
                                                    <td style={tdLabelStyle}>Presentation Type</td>
                                                    <td style={tdColonStyle}>:</td>
                                                    <th style={thValueStyle}>
                                                        {displayValue(tender?.presentation_type)}
                                                    </th>
                                                </tr>
                                            </>


                                        </tbody>
                                    </table>
                                )}
                                {/* Partners */}
                                {tab === 2 && showPartners && (
                                    <table style={tableStyle}>
                                        <tbody>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Lead Partner</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.lead_partner)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Lead Partner Share</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.lead_partner_share
                                                        ? `${tender?.lead_partner_share} %`
                                                        : ""}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>JV Partner</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.jv_partner_name)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>JV Partner Share</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.jv_partner_share
                                                        ? `${tender?.jv_partner_share} %`
                                                        : ""}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Associate Partner</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.assosiate_partner === "Other"
                                                        ? tender?.custom_assosiate_partner
                                                        : displayValue(tender?.assosiate_partner)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Associate Partner Share</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.associate_partner_share
                                                        ? `${tender?.associate_partner_share} %`
                                                        : ""}
                                                </th>
                                            </tr>

                                            {/* ✅ Added Fields */}

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Bid Prepare By</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.bid_prepare_by
                                                        ? tender?.bid_prepare_by.replace(/_/g, " ").toUpperCase()
                                                        : ""}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Bid Prepare By Remarks</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.bid_prepare_by_remarks)}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>BG Prepare By</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.bg_prepare_by
                                                        ? tender?.bg_prepare_by.replace(/_/g, " ").toUpperCase()
                                                        : ""}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Team Required</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.team_required ? "Yes" : "No"}
                                                </th>
                                            </tr>

                                            {tender?.team_required && (
                                                <>
                                                    <tr style={trStyle}>
                                                        <td style={tdLabelStyle}>Team Prepare By</td>
                                                        <td style={tdColonStyle}>:</td>
                                                        <th style={thValueStyle}>
                                                            {displayValue(tender?.team_prepare_by)}
                                                        </th>
                                                    </tr>

                                                    <tr style={trStyle}>
                                                        <td style={tdLabelStyle}>Team Requirement Details</td>
                                                        <td style={tdColonStyle}>:</td>
                                                        <th style={thValueStyle}>
                                                            {displayValue(tender?.team_requirements_details)}
                                                        </th>
                                                    </tr>

                                                    <tr style={trStyle}>
                                                        <td style={tdLabelStyle}>Team Prepare By Remarks</td>
                                                        <td style={tdColonStyle}>:</td>
                                                        <th style={thValueStyle}>
                                                            {displayValue(tender?.team_prepare_by_remarks)}
                                                        </th>
                                                    </tr>
                                                </>
                                            )}


                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Tender Submission Type</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.tender_submission_type)}
                                                </th>
                                            </tr>

                                        </tbody>
                                    </table>
                                )}
                                {/* Submission */}
                                {tab === 3 && showSubmission && (
                                    <table style={tableStyle}>
                                        <tbody>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Checklist</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.checklist ? "YES" : "NO"}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>All Docs Done</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.all_docs_done ? "YES" : "NO"}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>Total Tech Score</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {displayValue(tender?.tech_score)}
                                                </th>
                                            </tr>

                                            {/* ✅ Added from your first UI */}
                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>CV Score</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.cv_score ? tender?.cv_score : "-"}
                                                </th>
                                            </tr>

                                            <tr style={trStyle}>
                                                <td style={tdLabelStyle}>All CV's Done</td>
                                                <td style={tdColonStyle}>:</td>
                                                <th style={thValueStyle}>
                                                    {tender?.all_cvs_done ? "YES" : "NO"}
                                                </th>
                                            </tr>

                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BidDetails;
